import React, {Component} from 'react'
import {connect} from 'react-redux'
import {buildUrlFromParams} from '../../common/functions/url'
import WithAjax from '../../common/helpers/WithAjax'
import {setJumbotronTitle} from '../../../actions/common'
import OfferList from '../OfferList'


class OfferSearchAndList extends Component {
  constructor() {
    super()
    this.search = this.search.bind(this)

    this.state = {
      items: []
    }
  }

  componentDidMount() {
    this.props.setJumbotronTitle('Active offers');
    this.search();
  }

  search() {
    let url = buildUrlFromParams(
      'vacancies/active',{});

    this.props.ajax.get(url, true, (data) => {
      data.forEach((el, index) => {
        if(data[index].OfferType === 'VoiceTest') {
          data[index].NavigationParam = 'voicetests/' + data[index].Id;
        }
        else {
          data[index].NavigationParam = 'vacancies/' + data[index].Id;
        }
      });
      
      this.setState({
        items: data
      })
    })
  }

  render() {
    return (
      <div>
        <OfferList items={this.state.items} />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({})
const mapDispatchToProps = dispatch => ({
  setJumbotronTitle(title) { dispatch(setJumbotronTitle(title)) }
})
export default connect(mapStateToProps, mapDispatchToProps)(WithAjax(OfferSearchAndList))
